<template>
  <v-bottom-sheet
      v-model="sheet"
      scrollable
      persistent
      no-click-animation
      :overlay-opacity="0.7"
      :retain-focus="false"
      content-class="bottom-sheet min-height-auto"
  >
    <v-card>
      <v-card-title>
        참고문헌
        <v-spacer />
        <v-btn icon @click="sheetOpen(false)">
          <Close/>
        </v-btn>
      </v-card-title>
      <v-card-text ref="card">
        <div class="text-area">
          <strong>여행지원서는 이지앤웰니스(주)에서 독자적으로 개발한 심리검사로, 타당도와 신뢰도가 검증되었습니다.<br/>
          검증 과정에서 아래의 주요 척도들을 참고하였습니다.</strong><br/>
          <br/>
          <strong> ● 우울</strong> : CES-D(한국판 역학연구 우울척도), PHQ-9(한국판 우울증 선별도구)<br/>
          <strong> ● 스트레스</strong> : PSS(지각된 스트레스 척도)<br/>
          <strong> ● 불안</strong> : K-ANX(한국 불안 척도, GAD-7(범불안장애 선별도구)<br/>
          <strong> ● 마음날씨</strong> : K-6(한국어판 정신건강 선별도구)<br/>
          <strong> ● 마음나무</strong> : RSES(로젠버그 자아존중감척도), KRQ(회복탄력성척도)<br/>
        </div>
      </v-card-text>
    </v-card>
  </v-bottom-sheet>
</template>
<script>
import Close from '@/components/icons/Close'

export default {
  data: () => ({
    sheet: false,
  }),
  watch: {
  },
  components: {
    Close,
  },
  methods: {
    sheetOpen(flag) {
      this.sheet = flag;
    },
  }
}
</script>
<style lang="scss" scoped>
.text-area {
  //min-height: 210px;
  //background: #F4F4F4;
  //overflow-y: auto;
  //font-size: 14px;
  //color: #101010;
  //border-radius: 6px;
  //padding: 16px;
}
</style>
